import axios from "./axios"

function create (data) {
    return axios().post("/measure-units", data, {
        headers: {
            "X-Request-ID": data.idempotentKey
        }
    })
} 
function update(data) {
    return axios().put(`/measure-units/${data.id}`, data);
}

function findByID(id) {
    return axios().get(`/measure-units/${id}`);
}
function remove(data) {
    return axios().delete(`/measure-units/${data.id}`);
}

function index(params) {
    params.limit = params.itemsPerPage;
    params.offset = (params.page - 1) * params.itemsPerPage;
    
    return axios().get("/measure-units", {params});
}

function search(query) {
    return axios().get("/measure-units-search", {
        params: {
            search: query
        }
    })
}
export default {
    create,
    update,
    findByID,
    remove,
    index,
    search
}